import React from "react";
import Select, { components } from "react-select";
import downArrowSvg from "assets/img/arrow-down.svg";

interface DropdownProps {
  value: any;
  name?: string;
  options: any[];
  noOptionsMessage?: any;
  className?: string;
  classNamePrefix?: string;
  image?: string;
  placeholder?: string;
  containerStyles?: object;
  controlStyles?: object;
  onChange?: (newValue: any, action: object) => void;
  onInputChange?: (newValue: any, action: object) => void;
  isDisabled?: boolean;
  isSearchable?: boolean;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
  formatOptionLabel?: any;
  dataQa?: string;
  closeMenuOnSelect?: boolean;
  isMulti?: boolean;
  blurInputOnSelect?: boolean;
  noShadow?: boolean;
  backgroundFill?: boolean;
  placeholderStyles?: object;
}

const SelectDropdown: React.FunctionComponent<DropdownProps> = ({
  backgroundFill,
  noShadow,
  containerStyles,
  controlStyles,
  dataQa,
  image = downArrowSvg,
  isSearchable = false,
  placeholderStyles,
  ...restProps
}) => (
  <Select
    blurInputOnSelect={true}
    styles={{
      multiValueLabel: (styles) => ({ ...styles, textOverflow: "ellipsis" }),
      container: (base, state) => ({
        ...base,
        zIndex: state.selectProps.menuIsOpen ? 2 : "inherit",
        marginLeft: "auto",
        fontSize: 11,
        fontWeight: "normal",
        fontFamily: "Arial",
        color: "#FFFFFF", // white text color
        minWidth: 200,
        alignSelf: "flex-start",
        textTransform: "capitalize",
        backgroundColor: backgroundFill ? "transparent" : "transparent",
        ...containerStyles,
        // zIndex: 1000,
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        ...placeholderStyles,
      }),
      indicatorSeparator: () => ({ display: "none" }),
      control: (base, state) => ({
        ...base,
        border: "1px solid #DFDFDF", // updated border color
        borderRadius: 16, // rounded corners
        color: "#FFFFFF",
        boxShadow: "none",
        backgroundColor: "transparent",
        "&:hover": { borderColor: "#DFDFDF" },
        ...controlStyles,
      }),
      menu: (base) => ({
        ...base,
        margin: 0,
        borderRadius: 16,
      }),
      menuPortal: (base) => ({
        ...base,
        zIndex: 999999,
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#F5BC3454" : state.isFocused ? "#FFCD563B" : "",
        color: state.isSelected ? "#FFFFFF" : "#4A4A4A",
        borderRadius: 8,
      }),
      singleValue: (base, state) => ({
        ...base,
        color: "#4A4A4A",
      }),
      valueContainer: (base, state) => ({
        ...base,
        flexWrap: state.selectProps.menuIsOpen ? "wrap" : "nowrap",
      }),
    }}
    menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
    menuPosition="fixed"
    menuShouldScrollIntoView={false}
    components={{
      MultiValueRemove: (multiValueProps) =>
        components.MultiValueRemove && (
          <span
            data-qa={(multiValueProps as any).data["data-qa"] + "-remove"}
            style={{ display: "flex" }}
          >
            <components.MultiValueRemove {...multiValueProps} />
          </span>
        ),
      DropdownIndicator: (dropdownProps) =>
        components.DropdownIndicator && (
          <span data-qa={dataQa}>
            <components.DropdownIndicator {...dropdownProps}>
              <img src={image} alt="" />
            </components.DropdownIndicator>
          </span>
        ),
      Option: (optionProps) => (
        <span data-qa={(optionProps as any).data["data-qa"]}>
          <components.Option {...optionProps} />
        </span>
      ),
      Placeholder: (placeholderProps) => (
        <div style={{height: "40px"}}>
          <components.Placeholder {...placeholderProps} />
        </div>
      ),
    }}
    isSearchable={isSearchable}
    {...restProps}
    data-qa={dataQa}
  />
);

export default SelectDropdown;
